module.exports = __webpack_public_path__ + "img/Monte_Kope_121.75a195df.jpg";